<button
  type="button"
  class="flex flex-row justify-center items-center gap-2 border-[1px] border-[#f1ad00] bg-[#fff7e0] rounded-[6px] py-2 px-4 box-border w-full"
  *ngIf="shouldCreateShipping() && !edit; else locationField"
  (click)="toggleEdit()"
  [disabled]="!isActivated"
>
  <ui-icon name="gps" fill="neutrals-900" m-size="20" size="20" />
  <ui-paragraph
    type="p12"
    mobile-type="p12"
    font-weight="semibold"
    text-color="neutrals-900"
  >
    Agregar ubicación
  </ui-paragraph>
</button>

<ng-template #locationField>
  <div
    class="bg-neutrals-100 p-3 rounded-[8px] flex flex-col gap-3"
    *ngIf="!edit"
    #hoverBox
    (mouseenter)="
      hoverBox.classList.toggle('border-neutrals-400'); hovered = true
    "
    (mouseleave)="
      hoverBox.classList.toggle('border-neutrals-400'); hovered = false
    "
  >
    <div class="flex flex-row gap-3">
      <ui-icon
        class="flex-none"
        name="gps"
        size="16"
        mSize="16"
        fill="neutrals-600"
      />

      <div class="flex flex-col flex-grow gap-1">
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          font-weight="semibold"
          text-color="neutrals-900"
        >
          {{ shipping.district ? shipping.district : '---' }},
          {{ shipping.province ? shipping.province : '---' }},
          {{ shipping.department ? shipping.department : '---' }}
        </ui-paragraph>
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          font-weight="regular"
          text-color="neutrals-900"
        >
          {{ shipping.addressName ? shipping.addressName : 'No especificado' }}
        </ui-paragraph>
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          font-weight="regular"
          text-color="neutrals-900"
        >
          <b>Latitud:</b> {{ shipping.latitude ? shipping.latitude : '---' }}
        </ui-paragraph>
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          font-weight="regular"
          text-color="neutrals-900"
        >
          <b>Longitud:</b> {{ shipping.longitude ? shipping.longitude : '--' }}
        </ui-paragraph>
      </div>

      <div class="flex-none">
        <button
          *ngIf="hovered"
          (click)="toggleEdit()"
          [disabled]="!isActivated"
        >
          <ui-icon
            name="edit"
            size="16"
            mSize="16"
            fill="neutrals-600"
            matTooltip="Editar"
          />
        </button>
      </div>
    </div>
    <button
      class="flex flex-col items-center justify-center w-full cursor-pointer"
    >
      <img
        class="w-full"
        [src]="shipping.locationStaticMapUrl"
        alt=""
        (click)="openGoogleMaps(shipping)"
      />
    </button>
  </div>
</ng-template>

<form
  [formGroup]="form"
  class="border-[1px] border-unicon-yellow-100 rounded-[8px] box-border p-3 grid grid-flow-row gap-4"
  *ngIf="edit"
  (submit)="onSubmit()"
>
  <div class="flex items-center justify-center">
    <ui-paragraph
      type="p12"
      mobile-type="p12"
      text-color="neutrals-700"
      font-weight="semibold"
    >
      Agregar ubicación
    </ui-paragraph>
  </div>
  <div class="grid grid-flow-row gap-2">
    <div
      class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
      #departmentBox
    >
      <!-- <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
      <input
        type="text"
        placeholder="Departamento"
        formControlName="department"
        (focus)="departmentBox.classList.toggle('border-neutrals-900')"
        (blur)="departmentBox.classList.toggle('border-neutrals-900')"
      /> -->
      <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
      <select
        formControlName="department"
        (focus)="onFocusDepartment()"
        (blur)="departmentBox.classList.remove('focussed')"
        (change)="onSelectDepartment($event)"
      >
        <option [ngValue]="null" disabled selected hidden>Departamento</option>
        <option *ngFor="let department of departments" [value]="department">
          {{ department }}
        </option>
      </select>
    </div>
    <div
      class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
      #provinceBox
    >
      <!--  <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
      <input
        type="text"
        placeholder="Provincia"
        formControlName="province"
        (focus)="provinceBox.classList.toggle('border-neutrals-900')"
        (blur)="provinceBox.classList.toggle('border-neutrals-900')"
      /> -->
      <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
      <select
        formControlName="province"
        (focus)="provinceBox.classList.add('focussed')"
        (blur)="provinceBox.classList.remove('focussed')"
        (change)="onSelectProvince($event)"
      >
        <option [ngValue]="null" disabled selected hidden>Provincia</option>
        <option *ngFor="let province of provinces" [value]="province">
          {{ province }}
        </option>
      </select>
    </div>
    <div
      class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
      #districtBox
    >
      <!-- <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
      <input
        type="text"
        placeholder="Distrito"
        formControlName="district"
        (focus)="districtBox.classList.toggle('border-neutrals-900')"
        (blur)="districtBox.classList.toggle('border-neutrals-900')"
      /> -->
      <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
      <select
        formControlName="district"
        (focus)="districtBox.classList.add('focussed')"
        (blur)="districtBox.classList.remove('focussed')"
        (change)="onSelectDistrict($event)"
      >
        <option [ngValue]="null" disabled selected hidden>Distrito</option>
        <option *ngFor="let district of districts" [value]="district">
          {{ district }}
        </option>
      </select>
    </div>
    <div
      class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
      #addressNameBox
    >
      <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
      <input
        type="text"
        placeholder="Dirección"
        formControlName="addressName"
        (focus)="onFocusAddress()"
        (blur)="addressNameBox.classList.toggle('border-neutrals-900')"
      />
    </div>
    <div class="flex items-center justify-center my-3">
      <ui-paragraph
        type="p14"
        mobile-type="p14"
        text-color="neutrals-500"
        font-weight="regular"
      >
        o
      </ui-paragraph>
    </div>
    <div
      class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
      #latitudeBox
    >
      <ui-icon name="location" size="16" mSize="16" fill="neutrals-600" />
      <input
        type="text"
        placeholder="Latitud"
        formControlName="latitude"
        (focus)="onFocusLatitude()"
        (blur)="latitudeBox.classList.toggle('border-neutrals-900')"
      />
    </div>
    <div
      class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
      #longitudeBox
    >
      <ui-icon name="location" size="16" mSize="16" fill="neutrals-600" />
      <input
        type="text"
        placeholder="Longitud"
        formControlName="longitude"
        (focus)="onFocusLongitude()"
        (blur)="longitudeBox.classList.toggle('border-neutrals-900')"
      />
    </div>
  </div>
  <div class="grid grid-flow-col gap-2">
    <button class="btn-cancel" type="button" (click)="closeEdit()">
      <ui-paragraph
        type="p14"
        mobile-type="p14"
        text-color="neutrals-900"
        font-weight="semibold"
      >
        Cancelar
      </ui-paragraph>
    </button>
    <button class="btn-submit" type="submit" [disabled]="!form.valid">
      <ui-paragraph
        type="p14"
        mobile-type="p14"
        [textColor]="form.valid ? 'primary-700' : 'neutrals-0'"
        font-weight="semibold"
      >
        Guardar
      </ui-paragraph>
    </button>
  </div>
</form>
